import img1 from '../../../../../../../assets/img/form1.png';
import img2 from '../../../../../../../assets/img/form2.png';
import img3 from '../../../../../../../assets/img/form3.png';

const textDescription = {
  uz: 'Biz har doim savollaringizga javob berishga va sizga yordam berishga tayyormiz. Biz bilan bog‘lanish uchun telefon, email yoki messenjerlardan foydalanishingiz mumkin. Har bir mijoz biz uchun muhim va biz tezkor hamda sifatli qo‘llab-quvvatlashni taqdim etishga harakat qilamiz.',
  ru: 'Мы всегда готовы ответить на ваши вопросы и помочь вам. Свяжитесь с нами удобным для вас способом – через телефон, email или мессенджеры. Мы ценим каждого клиента и стараемся предоставить оперативную и качественную поддержку.',
  en: 'We are always ready to answer your questions and assist you. You can contact us via phone, email, or messengers. We value each client and strive to provide fast and high-quality support.',
  tr: 'Sorularınızı yanıtlamaya ve size yardımcı olmaya her zaman hazırız. Telefon, e-posta veya mesajlaşma uygulamalarıyla bizimle iletişime geçebilirsiniz. Her müşteriyi önemsiyor ve hızlı, kaliteli destek sağlamaya çalışıyoruz.',
  tj: 'Мо ҳамеша омодаем ба саволҳои шумо ҷавоб диҳем ва ба шумо кӯмак расонем. Шумо метавонед бо мо тавассути телефон, почтаи электронӣ ё паёмрасонҳо тамос гиред. Ҳар як муштарӣ барои мо муҳим аст ва мо кӯшиш мекунем, ки дастгирии босифат ва фаврӣ пешниҳод кунем.',
  ky: 'Биз ар дайым суроолоруңузга жооп берип, сизге жардам берүүгө даярбыз. Биз менен байланышуу үчүн телефон, электрондук почта же мессенджерлерди колдонсоңуз болот. Ар бир кардар биз үчүн маанилүү жана биз ыкчам жана сапаттуу колдоо көрсөтүүгө аракет кылабыз.'
};

export const webFormData = [
  {
    name: 'NEO Classic',
    pipeStatusId: 80,
    autofill: true,
    style: {
      id: 450,
      fieldBorderType: 'SQUARE',
      fieldHeight: 40,
      fieldBorderColor: '',
      fieldBackgroundColor: '',
      fieldSize: null,
      borderRadius: 0,
      borderColor: '#2b8cd1',
      boxShadow: false,
      fontColor: '#2b8cd1',
      fontFamily: 'sans-serif',
      labelPosition: 'TOP',
      leftBackgroundImage: '',
      leftBackgroundColor: '#2b8cd1',
      leftWidth: 546,
      rightBackgroundImage: '',
      rightBackgroundColor: '#ffffff',
      rightWidth: 569,
      height: 744,
      pageBackgroundColor1: '#75e2e9',
      pageBackgroundImage: ''
    },
    tagIds: [1, 2, 3],
    link: 'https://form.uysot.uz/gvlq94E',
    textSubmission: 'Muvaffaqqiyatli!',
    redirectUrl: 'https://uysot.uz',
    redirectTime: 3,
    elements: [
      {
        step: 1,
        companyLeadFieldDto: null,
        label: 'Phone',
        placeHolder: '',
        required: true,
        requiredMessage: '',
        companyLeadFieldId: null,
        type: null
      }
    ],
    staticElementFormDto: [
      {
        text: {
          uz: "Biz bilan bog'laning",
          ru: 'Свяжитесь с нами',
          en: 'Contact us',
          tr: 'Bizimle iletişime geçin',
          tj: 'Бо мо тамос гиред',
          ky: 'Биз менен байланышыңыз'
        },
        type: 'HEADER',
        textSize: 34,
        textColor: '#ffffff',
        alignment: 'LEFT',
        fontStyle: ['BOLD'],
        buttonBorderType: null,
        buttonWidth: null,
        buttonColor: null
      },
      {
        text: textDescription,
        type: 'PARAGRAPH',
        textSize: 18,
        textColor: '#ffffff',
        alignment: 'LEFT',
        fontStyle: [],
        buttonBorderType: null,
        buttonWidth: null,
        buttonColor: null
      },
      {
        text: {
          uz: 'Yuborish',
          ru: 'Отправить',
          en: 'Send',
          tr: 'Gönder',
          tj: 'Фиристодан',
          ky: 'Жөнөтүү'
        },
        type: 'BUTTON',
        textSize: null,
        textColor: '#fff',
        alignment: 'LEFT',
        fontStyle: [],
        buttonBorderType: 'SQUARE',
        buttonWidth: 296,
        buttonColor: '#2b8cd1'
      }
    ],
    createdDate: '22.01.2024 14:03:36',
    img: img2
  },
  {
    name: 'Modern',
    pipeStatusId: 80,
    autofill: true,
    style: {
      id: 475,
      fieldBorderType: 'SQUARE',
      fieldHeight: 40,
      fieldBorderColor: '',
      fieldBackgroundColor: '',
      fieldSize: null,
      borderRadius: 40,
      borderColor: '#922bd1',
      boxShadow: false,
      fontColor: '#922bd1',
      fontFamily: 'sans-serif',
      labelPosition: 'LEFT',
      leftBackgroundImage: '',
      leftBackgroundColor: '#922bd1',
      leftWidth: 542,
      rightBackgroundImage: '',
      rightBackgroundColor: '#ffffff',
      rightWidth: 557,
      height: 696,
      pageBackgroundColor1: '#f7f7f7',
      pageBackgroundImage: ''
    },
    tagIds: [1],
    link: 'https://form.uysot.uz/rhVy4p3',
    textSubmission: 'Muvaffaqqiyatli!',
    redirectUrl: '',
    redirectTime: 0,
    elements: [
      {
        step: 1,
        companyLeadFieldDto: null,
        label: 'Phone',
        placeHolder: '',
        required: true,
        requiredMessage: '',
        companyLeadFieldId: null,
        type: null
      }
    ],
    staticElementFormDto: [
      {
        text: {
          uz: "Biz bilan bog'laning",
          ru: 'Свяжитесь с нами',
          en: 'Contact us',
          tr: 'Bizimle iletişime geçin',
          tj: 'Бо мо тамос гиред',
          ky: 'Биз менен байланышыңыз'
        },
        type: 'HEADER',
        textSize: 32,
        textColor: '#ffffff',
        alignment: 'LEFT',
        fontStyle: [],
        buttonBorderType: null,
        buttonWidth: null,
        buttonColor: null
      },
      {
        text: textDescription,
        type: 'PARAGRAPH',
        textSize: 18,
        textColor: '#ffffff',
        alignment: 'LEFT',
        fontStyle: [],
        buttonBorderType: null,
        buttonWidth: null,
        buttonColor: null
      },
      {
        text: {
          uz: 'Yuborish',
          ru: 'Отправить',
          en: 'Send',
          tr: 'Gönder',
          tj: 'Фиристодан',
          ky: 'Жөнөтүү'
        },
        type: 'BUTTON',
        textSize: null,
        textColor: '#fff',
        alignment: 'LEFT',
        fontStyle: [],
        buttonBorderType: 'ELLIPSE',
        buttonWidth: 333,
        buttonColor: '#922bd1'
      }
    ],
    createdDate: '22.01.2024 17:11:04',
    img: img1
  },
  {
    name: 'Cyberpunk',
    pipeStatusId: 80,
    autofill: true,
    style: {
      fieldBorderType: 'SQUARE',
      fieldHeight: 40,
      fieldBorderColor: '#ffffff',
      fieldBackgroundColor: '#ffffff',
      fieldSize: null,
      borderRadius: 0,
      borderColor: '#922bd1',
      boxShadow: false,
      fontColor: '#ffffff',
      fontFamily: 'sans-serif',
      labelPosition: 'TOP',
      leftBackgroundImage: '',
      leftBackgroundColor: '#ffffff',
      leftWidth: 542,
      rightBackgroundImage: '',
      rightBackgroundColor: '#922bd1',
      rightWidth: 557,
      height: 696,
      pageBackgroundColor1: '#ffffff',
      pageBackgroundImage: ''
    },
    tagIds: [1],
    link: 'https://form.uysot.uz/rhVy4p3',
    textSubmission: 'Muvaffaqqiyatli!',
    redirectUrl: '',
    redirectTime: 0,
    elements: [
      {
        step: 1,
        companyLeadFieldDto: null,
        label: 'Phone',
        placeHolder: '',
        required: true,
        requiredMessage: '',
        companyLeadFieldId: null,
        type: null
      }
    ],
    staticElementFormDto: [
      {
        text: {
          uz: "Biz bilan bog'laning",
          ru: 'Свяжитесь с нами',
          en: 'Contact us',
          tr: 'Bizimle iletişime geçin',
          tj: 'Бо мо тамос гиред',
          ky: 'Биз менен байланышыңыз'
        },
        type: 'HEADER',
        textSize: 32,
        textColor: '#922bd1',
        alignment: 'LEFT',
        fontStyle: [],
        buttonBorderType: null,
        buttonWidth: null,
        buttonColor: null
      },
      {
        text: textDescription,
        type: 'PARAGRAPH',
        textSize: 18,
        textColor: '#922bd1',
        alignment: 'LEFT',
        fontStyle: [],
        buttonBorderType: null,
        buttonWidth: null,
        buttonColor: null
      },
      {
        text: {
          uz: 'Yuborish',
          ru: 'Отправить',
          en: 'Send',
          tr: 'Gönder',
          tj: 'Фиристодан',
          ky: 'Жөнөтүү'
        },
        type: 'BUTTON',
        textSize: null,
        textColor: '#922bd1',
        alignment: 'LEFT',
        fontStyle: [],
        buttonBorderType: 'ELLIPSE',
        buttonWidth: 460,
        buttonColor: '#ffffff'
      }
    ],
    createdDate: '22.01.2024 17:11:04',
    img: img3
  }
];
